import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

const UnreadMessageIndicator = ({ count }: { count: number }) => {
  const { t } = useTranslation("discussions");

  if (count <= 0) {
    return null;
  }

  return (
    <Box
      bg={"#EAEAEA"}
      c={"black"}
      className="flex justify-center items-center my-2 py-1 w-full"
    >
      <Text fz="xs" className="text-center">
        {count === 1 ? t("unreadMessage") : t("unreadMessages", { count })}
      </Text>
    </Box>
  );
};

export default UnreadMessageIndicator;
